import { render } from "./auth-base.vue?vue&type=template&id=ebbbb178&scoped=true&ts=true"
import script from "./auth-base.vue?vue&type=script&lang=ts"
export * from "./auth-base.vue?vue&type=script&lang=ts"

import "./auth-base.vue?vue&type=style&index=0&id=ebbbb178&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebbbb178"]])

export default __exports__